import { TextInput } from './text.mjs';
import { registerCustomElement } from '../utils.mjs';

export class URLInput extends TextInput {}

registerCustomElement('imt-input-url', URLInput);
